import Vue from 'vue'

export const bus = new Vue()

export default {
    install(Vue) {
        Object.defineProperty(Vue.prototype, '$bus', {
            get: function() {
                return bus
            }
        })
        
        Vue.$bus = bus
    }
}
